import { createFileRoute } from "@tanstack/react-router";

import { AdAccountsPage } from "../features/campaigns/AdAccountsPage";
import { useMe } from "../features/auth/session";
import { useT } from "../i18n/I18nProvider";

export const Route = createFileRoute("/app/ad-accounts")({
  component: AdAccountsRoute,
});

function AdAccountsRoute() {
  const t = useT();
  const me = useMe();
  if (!me.data) return <p>{t("common.loading")}</p>;
  return <AdAccountsPage me={me.data} />;
}
